var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useMemo } from 'react';
import { applySpacings } from '../../utils/tailwind';
import { FillIcons, Icons } from './Icons';
import { icon, svgItems } from './styles';
import { stops } from './svgGradientStops';
export const Icon = (_a) => {
    var { name, size = 24, color, gradientColor, className } = _a, props = __rest(_a, ["name", "size", "color", "gradientColor", "className"]);
    const gradientId = useId();
    const rotation = gradientColor === 'rainbow' ? 90 : 134;
    const { mt, mb, ml, mr, my, mx, m } = props, ariaProps = __rest(props, ["mt", "mb", "ml", "mr", "my", "mx", "m"]);
    const IconComponent = Icons[name];
    const svgColor = gradientColor && gradientId ? `url(#${gradientId})` : color;
    const mode = FillIcons.includes(name) ? 'fill' : 'stroke';
    const getAriaHidden = () => {
        if (ariaProps['aria-label']) {
            return false;
        }
        if (ariaProps['aria-hidden'] !== undefined) {
            return ariaProps['aria-hidden'];
        }
        return true;
    };
    const svgClassNames = useMemo(() => {
        var _a;
        let base = svgItems.base;
        // If there is a specific `fill` or `stroke` class in the `className`, make sure to
        // ignore the ones in the `svgItems.base` for the `className` to be taken into account
        if ((className === null || className === void 0 ? void 0 : className.includes('fill')) || (className === null || className === void 0 ? void 0 : className.includes('stroke'))) {
            base = base.filter((c) => !(c.includes('fill') || c.includes('stroke')));
        }
        // Only apply the `fill-*` or `stroke-*` classes to the Icon based on its mode
        let classes = [...base, ...((_a = className === null || className === void 0 ? void 0 : className.split(' ')) !== null && _a !== void 0 ? _a : [])];
        if (!classes) {
            return;
        }
        classes = classes.filter((c) => !c.includes(mode === 'fill' ? 'stroke' : 'fill'));
        // If the `color` or `gradientColor` prop is set, remove the `stroke-*` and `fill-*` classes to make sure the inline color is set
        if (color || gradientColor) {
            return classes.filter((c) => !(c.includes('stroke') || c.includes('fill')));
        }
        return classes;
    }, [mode, color, className, gradientColor]);
    return (_jsxs("span", { className: icon({
            size,
            className: [applySpacings(props), svgClassNames],
        }), children: [gradientColor ? (_jsx("svg", { "aria-hidden": true, className: "pointer-events-none absolute", children: _jsx("defs", { children: _jsx("linearGradient", { id: gradientId, x1: "0%", y1: "0%", x2: "0%", y2: "100%", gradientTransform: `rotate(${180 + rotation}, 0.5, 0.5)`, children: stops[gradientColor].map(([color, offset]) => (_jsx("stop", { offset: offset, stopColor: color }, color))) }, gradientColor) }) })) : null, _jsx(IconComponent, Object.assign({ stroke: svgColor, fill: svgColor, "aria-hidden": getAriaHidden() }, ariaProps))] }));
};
